/// \file systemNotifications.tsx
///
/// \par Copyright Notice:
/// Copyright (c) 2023 by Oshkosh Corporation.
/// All Rights Reserved.
///
/// \par
/// The information contained herein is confidential and proprietary property
/// of Oshkosh Corporation, and may be privileged.  The dissemination,
/// distribution, use, copying, transfer, or disclosure of such information is
/// strictly prohibited except by express written agreement with Oshkosh
/// Corporation, or with one of its subsidiaries.

import {lazy, Suspense} from "react";
import { ActionFunctionArgs, LoaderFunctionArgs, Route } from "react-router-dom";

const SystemNotificationsList = lazy(() => import('../views/system-notifications/list/view'));

async function SystemNotificationsDataLoader(args: LoaderFunctionArgs) {
  const actualLoader = (await import('../views/system-notifications/list/loader')).default;
  return actualLoader(args);
}

export async function SystemNotificationsAction(args: ActionFunctionArgs) {
  const actualAction = (await import("../views/system-notifications/list/action")).action;
  return actualAction(args);
}

const routes = (
  <Route
    path="system-notifications"
    handle={{
      text:"SYSTEM NOTIFICATIONS"
    }}
  >
    <Route
      index
      element={
        <Suspense fallback={<div>Loading...</div>}>
          <SystemNotificationsList />
        </Suspense>
      }
      loader={SystemNotificationsDataLoader}
      action={SystemNotificationsAction}
      />
  </Route>
);

export default routes;